//* 组件库
import { $message, type UiModal } from "various-ui";
//* 全局函数
import { Systems } from "@/assets/js";
//* 组件属性
import { options } from "./options";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();

    //* 静态数据
    const vars = {
        more: { sequence: "", result: <{ status: string; context: string }[]>[] },
        single: { sequence: "", result: <{ status: string; context: string }[]>[] },
    };

    //* 响应式属性
    const refs = {
        mode: ref<string>("more"),
        result: ref<{ status: string; context: string }[]>([]),
        sequence: ref<string>(""),
        composing: ref<boolean>(false),
    };

    //* 节点
    const nodes = {
        info: ref<InstanceType<typeof UiModal>>(),
    };

    //* 函数列表
    const methods = {
        //* 序列解析函数
        analyze: () => {
            //* 检测序列是否输入
            if (!refs.sequence.value) $message.error(i18n.t("PleaseEnterTheSequenceAndTryAgain"));
            //* 序列解析
            refs.result.value = [];
            if (refs.mode.value == "more") {
                //* 记录失败字符
                let error = "";
                refs.sequence.value.split("").forEach((char, key) => {
                    const result = options.more[char.toLocaleUpperCase()];
                    if (result) {
                        if (error) {
                            refs.result.value.push({ status: "error", context: error });
                            error = "";
                        }
                        refs.result.value.push({ status: "success", context: result });
                    } else {
                        error += char;
                        if (key == refs.sequence.value.length - 1) refs.result.value.push({ status: "error", context: error });
                    }
                });
            } else {
                //* 记录失败字符
                let error = "";
                const size = Math.ceil(refs.sequence.value.length / 3);
                for (let i = 0; i < size; i++) {
                    const key = refs.sequence.value.slice(i * 3, (i + 1) * 3).toLocaleUpperCase();
                    const result = options.single[key];
                    if (result) {
                        if (error) {
                            refs.result.value.push({ status: "error", context: error });
                            error = "";
                        }
                        refs.result.value.push({ status: "success", context: result });
                    } else {
                        error += key;
                        if (i == size - 1) refs.result.value.push({ status: "error", context: error });
                    }
                }
            }
        },

        //* 序列处理函数
        handle: () => {
            if (!refs.composing.value) refs.sequence.value = refs.sequence.value.replace(/[^A-Za-z]/g, "");
        },

        handleEnd: () => {
            refs.composing.value = false;
            refs.sequence.value = refs.sequence.value.replace(/[^A-Za-z]/g, "");
        },

        //* 重置函数
        reset: () => {
            refs.sequence.value = "";
            refs.result.value = [];
            if (refs.mode.value == "more") {
                vars.more.sequence = "";
                vars.more.result = [];
            } else {
                vars.more.sequence = "";
                vars.more.result = [];
            }
        },

        //* 跳转函数
        next: () => {
            if (i18n.locale.value == "zh") open("https://www.bilibili.com/video/BV1yVGXzqEQ5", "_blank");
            else {
                open("https://www.youtube.com/watch?v=Qmg87dUZ7ig", "_blank");
            }
        },

        //* 复制
        copy: () =>
            Systems.copyText(
                refs.result.value
                    .filter((value) => value.status == "success")
                    .map((value) => value.context)
                    .join("-")
            ),

        //* 模式切换
        mode: () => {
            if (refs.mode.value == "more") {
                vars.single.sequence = refs.sequence.value;
                vars.single.result = refs.result.value;
                refs.sequence.value = vars.more.sequence;
                refs.result.value = vars.more.result;
            } else {
                vars.more.sequence = refs.sequence.value;
                vars.more.result = refs.result.value;
                refs.sequence.value = vars.single.sequence;
                refs.result.value = vars.single.result;
            }
        },
    };

    return { refs, nodes, methods };
};
